import { FC, useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useValidation } from "components/form/useValidation";
import FormError, { errorClass } from "components/form/formError";
import FloatingField from "components/form/FloatingField/FloatingField";
import { ErrorMessage } from "@hookform/error-message";
import { AccountContext } from "auth/accountProvider";
import { useTranslation } from "react-i18next";
import InfoAlert from "components/alert/InfoAlert";

const SendCode: FC = () => {
  const { t } = useTranslation();
  const { sendCode } = useContext(AccountContext);
  const rules = useValidation();

  const location = useLocation();
  const locationState = location.state as {
    resetUsername: string;
  };

  const resetUsername = locationState?.resetUsername ?? "";

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [cognitoError, setCognitoError] = useState<string>("");
  const [emailSent, setEmailSent] = useState<boolean>(false);

  const handleSendCode = (form: any) => {
    const username = form.username.toLowerCase();
    setCognitoError("");
    sendCode(username)
      .then(() => {
        setEmailSent(true);
      })
      .catch((error: any) => {
        const translatedError = t(
          error,
          t("Send request unknown untranslated error")
        );
        setCognitoError(`${translatedError}`);
      });
  };

  if (emailSent) {
    return (
      <div>
        <InfoAlert text={t("send request success")} />
        <p className="send-code-hint">{t("send request check spam")}</p>
        <div className="form-group">
          <button
            id="send-code-try-again"
            data-testid="send-code-try-again"
            type="button"
            className="btn btn-primary btn-login"
            onClick={() => setEmailSent(false)}
          >
            {t("send request try again")}
          </button>
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-12">
              <Link to="/login" className="btn btn-link" id="back-button">
                <span className="vismaicon vismaicon-move-left-circle" />
                {t("back")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <form autoComplete="off" onSubmit={handleSubmit(handleSendCode)}>
      <InfoAlert text={t("send request explanation")} />
      <div className={`form-group required${errorClass(errors, "username")}`}>
        <FloatingField
          id="input-username"
          data-testid="input-username"
          type="text"
          label={t("username")}
          hasError={!!errors.username}
          {...register("username", { ...rules.required, ...rules.email })}
          defaultValue={resetUsername}
        />
        <ErrorMessage {...{ errors }} name="username" as={FormError} />
      </div>

      <div className="form-group">
        <button
          id="submit-send-code"
          data-testid="submit-send-code"
          type="submit"
          className="btn btn-primary btn-login"
        >
          {t("send request")}
        </button>
        {cognitoError && <FormError>{cognitoError}</FormError>}
      </div>

      <div className="form-group">
        <div className="row">
          <div className="col-12">
            <Link to="/login" className="btn btn-link" id="back-button">
              <span className="vismaicon vismaicon-move-left-circle" />
              {t("back")}
            </Link>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SendCode;
